import { EmpreenderApps } from "../lib/AppsArray";
import { useSubMenu } from "../SubMenuContext";
import { DrawerContent } from "../ui/Drawer";
import { useEffect, useState } from "react";

interface DashAreaProps {
    iframeSrc: string | null;
}

const DashArea = ({ iframeSrc }: DashAreaProps) => {
    const { app } = useSubMenu();

    const appEntry = EmpreenderApps.find((a) =>
        a.tags.some((tag) => tag?.toLowerCase() === app?.toLowerCase())
    );

    const [iframeLoaded, setIframeLoaded] = useState(false);
    const [minTimePassed, setMinTimePassed] = useState(false);

    useEffect(() => {
        setIframeLoaded(false);
        setMinTimePassed(false);
        if (!iframeSrc) return;

        const t = setTimeout(() => setMinTimePassed(true), 2000);
        return () => clearTimeout(t);
    }, [iframeSrc]);

    if (!appEntry) return null;

    const showIframe = minTimePassed && iframeLoaded;

    return (
        <DrawerContent className="!p-0 overflow-hidden !border-0" absolute>
            <div className="h-[calc(100vh-50px)] w-full relative">
                {!showIframe && (
                    <img
                        draggable={false}
                        className="absolute select-none pointer-events-none left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 w-[210px]"
                        src="https://empreender.nyc3.digitaloceanspaces.com/LP/im/4e0901637b61.gif"
                    />
                )}

                {iframeSrc && (
                    <iframe
                        className={`size-full relative transition-opacity duration-300 ${
                            showIframe ? "opacity-100" : "opacity-0"
                        }`}
                        src={iframeSrc}
                        onLoad={() => setIframeLoaded(true)}
                    />
                )}
            </div>
        </DrawerContent>
    );
};

export default DashArea;